

































import { ApiResponse } from '@/api/firebase'

import * as api from '../api/firebase';


import Vue from 'vue'
export default Vue.extend({

	data() {
		return {
		}
	},

	computed: {
		maps() {
			return this.$store.state.adminData ? this.$store.state.adminData.maps : undefined;
		},
		users() {
			return this.$store.state.adminData ? this.$store.state.adminData.users : undefined;
		}
	},

	methods: {
		getDate(s:string) {
			return new Date(s).toLocaleString("sv-SE");
		},

		hijackLink(evt) {
			evt.preventDefault();
			this.$router.push(new URL(evt.target.href).pathname);
		},

		reload() {
			this.$store.dispatch("loadAdminData");
		}

	},

	async mounted() {
		if(!this.$store.state.adminData) {
			this.$store.dispatch("loadAdminData");
		}
	}
})
